export const CAR_ID_FROM_DETAIL_TO_CAR_VERIFICATION = 'carId_from_detail_to_car_verification'; // 차량상세에서 검수리포트 진입 케이스 관련 키, 차량 상세에서 set, 검수리포트에서 get - 검증 실패 시 remove
export const CAR_ID_FROM_DETAIL_TO_REPORT_ACCIDENT = 'carId_from_detail_to_report_accident'; // 차량상세에서 보험이력 진입 케이스 관련 키, 차량 상세에서 set, 보험이력 get - 검증 실패 시 remove

export const EXPORT_TRANSLATE_GUIDE_CLOSE_VERIFICATION_KEY = 'export_translate_guide_close_verification';
export const EXPORT_TRANSLATE_GUIDE_CLOSE_REPORT_ACCIDENT_KEY = 'export_translate_guide_close_report_accident';

export const EXPORT_INTRO_MODAL_CLOSE_KEY = 'hide_export_intro_modal'; // 수출 안내 모달 닫힘 여부 관련 키
export const EXPORT_GATE_PATH = '/gate'; // 수출 게이트 페이지 경로 (services/global)

// 수출문의 진입 경로
export const EXPORT_LEAD_CASE = {
	CAR_DETAIL: 'carDetail',
	CAR_VERIFICATION_REPORT: 'carVerificationReport',
	CAR_REPORT_ACCIDENT: 'carReportAccident',
	EXPORT_ACQUISITION_COST: 'exportAcquisitionCost',
};
